var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-youtube",
    viewBox: "0 0 30 31",
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000488281,
    y: 0.508789,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3059 11.3418C23.1061 10.5998 22.521 10.0147 21.779 9.81489C20.4233 9.44386 15.0005 9.44386 15.0005 9.44386C15.0005 9.44386 9.57776 9.44386 8.22207 9.80062C7.49428 10.0004 6.89493 10.5998 6.69514 11.3418C6.33838 12.6975 6.33838 15.5088 6.33838 15.5088C6.33838 15.5088 6.33838 18.3343 6.69514 19.6757C6.89493 20.4178 7.48001 21.0029 8.22207 21.2027C9.59203 21.5737 15.0005 21.5737 15.0005 21.5737C15.0005 21.5737 20.4233 21.5737 21.779 21.217C22.521 21.0172 23.1061 20.4321 23.3059 19.69C23.6627 18.3343 23.6627 15.5231 23.6627 15.5231C23.6627 15.5231 23.6769 12.6975 23.3059 11.3418Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2739 18.106L17.7834 15.5088L13.2739 12.9116V18.106Z",
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.07b7c5f1ab4c530e67ba1adb0cd7baed.svg";
export { ForwardRef as ReactComponent };